var React = require('react');

function ServicesIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"10.541","y":"1.155","width":"3","height":"23.334","rx":"1.5","transform":"rotate(22.8 10.54 1.155)","stroke":"#6B3FFC","key":0}),React.createElement("rect",{"x":"10","y":"22","width":"14","height":"2","rx":"1","fill":"#6B3FFC","key":1}),React.createElement("ellipse",{"cx":"11.576","cy":"2.427","rx":"1.659","ry":"1.051","transform":"rotate(18.803 11.576 2.427)","fill":"#6B3FFC","key":2})]);
}

ServicesIcon.defaultProps = {"width":"24","height":"25","fill":"none"};

module.exports = ServicesIcon;

ServicesIcon.default = ServicesIcon;
